document.addEventListener('DOMContentLoaded', () => {
  console.log('SHOPIFY CART SYNC SCRIPT LOADED');

  let productQty = {};
  let planCompleted = false;

  /* ---------------- ELEMENTS ---------------- */

  const placeOrderBtn = document.getElementById('place-order-btn');
  const cartIcon = document.getElementById('cart-icon-bubble');

  const discountContainer = document.getElementById('discount-percent');
  const discountBadge = document.getElementById('discount-badge');
  const discounttext = document.getElementById('discount-text');

  /* ---------------- SHOPIFY CART HELPERS ---------------- */

  async function getShopifyCart() {
    const res = await fetch('/cart.js');
    return await res.json();
  }

  async function updateHeaderCartCount() {
    const cart = await getShopifyCart();
    const bubble = document.querySelector('.cart-count-bubble');
    if (!bubble) return;

    const countSpan = bubble.querySelector('span[aria-hidden="true"]');

    if (cart.item_count > 0) {
      countSpan.textContent = cart.item_count;
      bubble.style.display = 'flex';
    } else {
      countSpan.textContent = '';
      bubble.style.display = 'none';
    }
  }

  /* ---------------- DISCOUNT UI ---------------- */

  function updateDiscountUI(totalQty) {
    if (!discountContainer || !discountBadge) return;

    discountContainer.classList.remove('percent3','percent31','percent2','percent1','percent-0','percent-1','percent-2','percent-3','percent-4','percent-5', 'percent-10', 'percent-15');
    discountBadge.textContent = '';
    discounttext.textContent = '';

    // 15% at 20+
    if (totalQty >= 20) {
      discountContainer.classList.add('percent-15');
      discountBadge.textContent = '15%';
      discounttext.textContent = 'You have unlocked the best discount';
      return;
    }

    // 10% at 14-19
    if (totalQty >= 14) {
      discountContainer.classList.add('percent-10');
      discountBadge.textContent = '10%';
      const remaining = 20 - totalQty;
      discounttext.textContent = `Add ${remaining} more meal${remaining > 1 ? 's' : ''} to get 15% discount`;
      return;
    }

    // 5% at 10-13
    if (totalQty >= 10) {
      discountContainer.classList.add('percent-5');
      discountBadge.textContent = '5%';
      const remaining = 14 - totalQty;
      discounttext.textContent = `Add ${remaining} more meal${remaining > 1 ? 's' : ''} to get 10% discount`;
      return;
    }

    // Below 10
    if (totalQty >= 9) {
      discountContainer.classList.add('percent-4');
      const remaining = 10 - totalQty;
      discounttext.textContent = `Add ${remaining} more meal${remaining > 1 ? 's' : ''} to get 5% discount`;
      return;
    }
    if (totalQty == 8) {
      discountContainer.classList.add('percent31');
      const remaining = 10 - totalQty;
      discounttext.textContent = `Add ${remaining} more meal${remaining > 1 ? 's' : ''} to get 5% discount`;
      return;
    }
    if (totalQty == 7) {
      discountContainer.classList.add('percent-3');
      const remaining = 10 - totalQty;
      discounttext.textContent = `Add ${remaining} more meal${remaining > 1 ? 's' : ''} to get 5% discount`;
      return;
    }
    if (totalQty == 6) {
      discountContainer.classList.add('percent3');
      const remaining = 10 - totalQty;
      discounttext.textContent = `Add ${remaining} more meal${remaining > 1 ? 's' : ''} to get 5% discount`;
      return;
    }
    if (totalQty == 5) {
      discountContainer.classList.add('percent-2');
      const remaining = 10 - totalQty;
      discounttext.textContent = `Add ${remaining} more meal${remaining > 1 ? 's' : ''} to get 5% discount`;
      return;
    }
    if (totalQty == 4) {
      discountContainer.classList.add('percent2');
      const remaining = 10 - totalQty;
      discounttext.textContent = `Add ${remaining} more meal${remaining > 1 ? 's' : ''} to get 5% discount`;
      return;
    }
    if (totalQty == 3) {
      discountContainer.classList.add('percent-1');
      const remaining = 10 - totalQty;
      discounttext.textContent = `Add ${remaining} more meal${remaining > 1 ? 's' : ''} to get 5% discount`;
      return;
    }
    if (totalQty == 2) {
      discountContainer.classList.add('percent1');
      const remaining = 10 - totalQty;
      discounttext.textContent = `Add ${remaining} more meal${remaining > 1 ? 's' : ''} to get 5% discount`;
      return;
    }
    if (totalQty == 1) {
      discountContainer.classList.add('percent-0');
      const remaining = 10 - totalQty;
      discounttext.textContent = `Add ${remaining} more meal${remaining > 1 ? 's' : ''} to get 5% discount`;
      return;
    }
    if (totalQty > 0) {
      discountContainer.classList.add('percent-0');
      const remaining = 10 - totalQty;
      discounttext.textContent = `Add ${remaining} more meal${remaining > 1 ? 's' : ''} to get 5% discount`;
    }
  }


  /* ---------------- UI HELPERS ---------------- */

  function setWrapperLoading(wrapper, loading) {
    const buttons = wrapper.querySelectorAll('button');
    buttons.forEach(b => (b.disabled = loading));
  }

  function updatePlusButtons(totalQty) {
    planCompleted = totalQty > 0;

    document.querySelectorAll('.meal-qty').forEach(wrapper => {
      const productId = wrapper.dataset.productId;
      const qty = productQty[productId] || 0;

      const plus = wrapper.querySelector('.plus');
      const minus = wrapper.querySelector('.minus');

      if (plus) plus.disabled = false;
      if (minus) minus.disabled = qty <= 0;
    });

    if (placeOrderBtn) {
      placeOrderBtn.style.display = planCompleted ? 'inline-block' : 'none';
    }
  }

  /* ---------------- GIFT CARD CHECK ---------------- */

  // Excludes any product whose title is exactly "Gift Cards" (case-insensitive).
  // To add more excluded titles, just add them to the array.
  function isGiftCard(item) {
    const excluded = ['gift cards'];
    return excluded.includes(item.product_title?.trim().toLowerCase());
  }

  /* ---------------- CART -> UI SYNC ---------------- */

  async function syncFromShopifyCart() {
    try {
      const cart = await getShopifyCart();

      productQty = {};

      // Reset UI quantities
      document.querySelectorAll('.meal-qty .qty-value').forEach(el => {
        el.textContent = '0';
      });

      // Exclude "Gift Cards" products from all meal rules
      const mealItems = cart.items.filter(item => !isGiftCard(item));
      const mealItemCount = mealItems.reduce((sum, item) => sum + item.quantity, 0);

      mealItems.forEach(item => {
        const variantId = item.variant_id;
        const quantity = item.quantity;

        document.querySelectorAll('.meal-qty').forEach(wrapper => {
          if (String(wrapper.dataset.variantId) === String(variantId)) {
            const productId = wrapper.dataset.productId;
            productQty[productId] = quantity;

            const valueEl = wrapper.querySelector('.qty-value');
            if (valueEl) valueEl.textContent = quantity;
          }
        });
      });

      updatePlusButtons(mealItemCount);
      updateDiscountUI(mealItemCount);
      updateHeaderCartCount(); // header shows total including gift cards

    } catch (err) {
      console.error('Failed to sync Shopify cart', err);
    }
  }

  /* ---------------- INIT MEAL QTY ---------------- */

  function initMealQty(wrapper) {
    if (wrapper.dataset.initialized) return;
    wrapper.dataset.initialized = 'true';

    const variantId = wrapper.dataset.variantId;
    const productId = wrapper.dataset.productId;

    const plus = wrapper.querySelector('.plus');
    const minus = wrapper.querySelector('.minus');
    const value = wrapper.querySelector('.qty-value');

    plus?.addEventListener('click', async () => {
      setWrapperLoading(wrapper, true);

      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      await syncFromShopifyCart();
      setWrapperLoading(wrapper, false);
    });

    minus?.addEventListener('click', async () => {
      const currentQty = Number(value.textContent);
      if (currentQty <= 0) return;

      setWrapperLoading(wrapper, true);

      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: currentQty - 1
        })
      });

      await syncFromShopifyCart();
      setWrapperLoading(wrapper, false);
    });
  }

  /* ---------------- OBSERVER ---------------- */

  new MutationObserver(() => {
    document.querySelectorAll('.meal-qty').forEach(initMealQty);
  }).observe(document.body, { childList: true, subtree: true });

  /* ---------------- PLACE ORDER ---------------- */

  async function proceedToCheckout() {
    const cart = await getShopifyCart();
    if (cart.item_count === 0) {
      alert('Your cart is empty');
      return;
    }

    window.location.href = '/cart';
  }

  placeOrderBtn?.addEventListener('click', proceedToCheckout);
  cartIcon?.addEventListener('click', e => {
    e.preventDefault();
    proceedToCheckout();
  });

  /* ---------------- INITIAL LOAD ---------------- */

  syncFromShopifyCart();
});

(function () {
  const observe = IntersectionObserver.prototype.observe;

  IntersectionObserver.prototype.observe = function (el) {
    if (!(el instanceof Element)) return;
    return observe.call(this, el);
  };
})();